import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'urban-invisible',
    templateUrl: './invisible.component.html',
    styleUrls: ['./invisible.component.scss'],
    standalone: false
})
export class InvisibleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
